import { OPTION, WARRANT } from 'common/constants/securityTypes';
import { CaptableColumn } from '../components/captable-table/CaptableTable.props';

const clearUnderlyingSecurity = (captableColumn: CaptableColumn): Pick<CaptableColumn, 'underlying_security_ref' | 'underlying_security' | 'options_ledger'> => {
  const {
    is_deleted: isDeleted,
    is_hidden: isHidden,
    security_type: securityType,
    underlying_security_ref: underlyingSecurityRef,
    underlying_security: underlyingSecurity,
    options_ledger: optionsLedger,
  } = captableColumn;
  // Only execute if column is not deleted and not hidden
  if (isDeleted || isHidden) {
    return {
      underlying_security_ref: underlyingSecurityRef,
      underlying_security: underlyingSecurity,
      options_ledger: optionsLedger,
    };
  }

  // Securities only have an underlying security and an options ledger if they are warrants or options
  if (!securityType || ![WARRANT, OPTION].includes(securityType)) {
    return {
      underlying_security_ref: null,
      underlying_security: null,
      options_ledger: [],
    };
  }

  // Keep the original values if the security is a warrant or option
  return {
    underlying_security_ref: underlyingSecurityRef,
    underlying_security: underlyingSecurity,
    options_ledger: optionsLedger,
  }
};

export default clearUnderlyingSecurity;
